import React, { useEffect, useState, useRef } from "react";
import rightArrow from "../../assets/images/rightArrow.svg";
import completed from "../../assets/images/completed.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPendingMonthsHandler } from "../../redux/action/getPendingMonths";
import Loader from "../../components/Loder/loader";
import { getUserProductClaimHandler } from "../../redux/action/getUserProductClaim";
// import { useTranslation } from "react-i18next";
import {
  updateUserProductClaimAction,
  updateUserProductClaimHandler,
} from "../../redux/action/updateUserProductClaim";
import { useCommonMessage } from "../../common/CommonMessage";
import NoDataFound from "../NoDataFound/NoDataFound";
import { getItem, setItem } from "../../common/localStorage";
import moment from "moment";
import { Modal } from "antd";
import { getProductFeaturesHandler } from "../../redux/action/getProductFeatures";

const Claims = () => {
  const [activeMonth, setActiveMonth] = useState(null);
  const [claimData, setClaimData] = useState([]);
  const currentMonthRef = useRef(null);
  const messageApi = useCommonMessage();
  const navigate = useNavigate();
  const getAdminId = getItem("adminId");
  const getGroupId = getItem("groupId");
  const getProductCode = getItem("productCode");

  const [showErrorMessageModal, setShowErrorMessageModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [storeItem, setStoreItem] = useState("");

  // const { t } = useTranslation();

  // const { state } = useLocation();
  const dispatch = useDispatch();

  const getPendingMonthsSelector = useSelector(
    (state) => state?.getPendingMonths
  );
 
  const getAllProductListSelector = useSelector(
    (state) => state?.getProductList
  );

  const getUserProductClaimSelector = useSelector(
    (state) => state?.getUserProductClaim
  );


  useEffect(() => {
    if (getAdminId && getAllProductListSelector?.data?.data?.products?.length>0) {
      let payload = {
        userId: getAdminId ?? 0,
        // groupId:  getGroupId,
        groupId: getGroupId
          ? getGroupId
          : getAllProductListSelector?.data?.data?.products[0].groupId,
        productCode: getProductCode
          ? getProductCode
          : getAllProductListSelector?.data?.data?.products[0].productCode,
      };
      dispatch(getProductFeaturesHandler(payload));
    }
  }, [getGroupId, getProductCode, getAllProductListSelector]);

  const updateUserProductClaimSelector = useSelector(
    (state) => state?.updateUserProductClaim
  );
  const getProductFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures
  );
  console.log(getProductFeaturesSelector,"Shreyashhhh");
  useEffect(() => {
    const pendingMonths =
      getPendingMonthsSelector?.data?.data?.pendingMonths || [];

    const monthWithError = pendingMonths.find((month) => month.errorMessage);
    if (monthWithError) {
      setErrorMessage(monthWithError.errorMessage);
      setShowErrorMessageModal(true);
    }else if(getPendingMonthsSelector?.data?.data?.pendingMonths?.find((item)=>item?.status === "complete")){
      setErrorMessage("");
      setShowErrorMessageModal(false);
      setActiveMonth(null)
    }
  }, [getPendingMonthsSelector]);


  useEffect(() => {
    const pendingMonths = getPendingMonthsSelector?.data?.data?.pendingMonths;
    const currentFormattedMonth = moment().format("MMM 'YY");
    if (pendingMonths?.length > 0) {
      const match = pendingMonths.find(
        (item) => item?.value === currentFormattedMonth
      );
      if (match) {
        setActiveMonth(match);
      }
    }
  }, [getPendingMonthsSelector]);

  useEffect(() => {
    if (currentMonthRef.current) {
      currentMonthRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [activeMonth]);

  

  useEffect(() => {
    if (getAdminId && getAllProductListSelector?.data?.statusCode === 200) {
      let payload = {
        userId: getAdminId ?? 0,
        groupId: getGroupId
          ? getGroupId
          : getAllProductListSelector?.data?.data?.products[0].groupId,
        productCode: getProductCode
          ? getProductCode
          : getAllProductListSelector?.data?.data?.products[0].productCode,
      };
      dispatch(getPendingMonthsHandler(payload));
    }
  }, [getAllProductListSelector,getProductFeaturesSelector]);
  // Get Claim list useEffect
  useEffect(() => {
    if (getPendingMonthsSelector?.data?.statusCode === 200 && activeMonth) {
      // Check for error message before making the API call
      if (activeMonth.errorMessage) {
        setErrorMessage(activeMonth.errorMessage);
        setShowErrorMessageModal(true);
        return;
      }

      let payload = {
        userId: getAdminId ?? 0,
        groupId: getGroupId
          ? getGroupId
          : getAllProductListSelector?.data?.data?.products[0].groupId,
        productCode: getProductCode
          ? getProductCode
          : getAllProductListSelector?.data?.data?.products[0].productCode,
        targetMonth: activeMonth
          ? activeMonth?.value
          : getPendingMonthsSelector?.data?.data?.pendingMonths?.[0],
      };
      dispatch(getUserProductClaimHandler(payload));
    }
  }, [activeMonth]);

  useEffect(() => {
    if (activeMonth) {
      const tempData = getUserProductClaimSelector?.data?.data?.claim?.map(
        (item) => {
          if (
            item.claimType === "url" ||
            item.claimType === "form" ||
            item?.claimType === "offlineClaim" ||
            item?.claimType === "doctorVisit" ||
            item?.claimType === "quiz"
          ) {
            return item;
          }
        }
      );
      setClaimData(tempData);
    }
  }, [getUserProductClaimSelector, activeMonth]);

  useEffect(() => {
    const currentMonth = moment().format("MMM 'YY");
    const pendingMonths = getPendingMonthsSelector?.data?.data?.pendingMonths || [];
  
    // Only run this logic if activeMonth is not set
    if (!activeMonth) {
      const currentMonthData = pendingMonths.find(month => month.value === currentMonth);
      if (currentMonthData) {
        setItem("clickedMonth", currentMonth);
        setActiveMonth(currentMonthData);
      }
    }
  }, [getPendingMonthsSelector]); // Removed activeMonth from dependency

  const handleMonthsWiseData = (item) => {
    setItem("clickedMonth", item?.value);
    setActiveMonth(item);
  };

  const handleYesClick = () => {
    const pendingMonths = getPendingMonthsSelector?.data?.data?.pendingMonths || [];
    const currentIndex = pendingMonths.findIndex(month => month.value === activeMonth?.value);
    if (currentIndex > 0) {
      handleMonthsWiseData(pendingMonths[currentIndex - 1]);
    }
    setShowErrorMessageModal(false);
  };


  const handleClaimCards = (item) => {
    setItem("claimDetails", item);
    if (item?.claimType === "url") {
      const updatedData = claimData.map((obj) => {
        if (obj?.id === item.id) {
          return {
            ...obj,
            claimStatus: "COMPLETE",
          };
        }
        return obj;
      });

      const payload = {
        id: getUserProductClaimSelector?.data?.data?.id,
        isSubmit: true,
        claimType: item?.claimType,
        claim: updatedData,
        claimId: item?.id,
      };

      dispatch(updateUserProductClaimHandler(payload));
      // window.open(item?.urlData, "_blank");
      setStoreItem(item)
    } else if (item?.claimType === "form") {
      navigate("/form-info", {
        state: {
          item: item,
          getUserProductClaimSelector: getUserProductClaimSelector,
        },
      });
    } else if (item?.claimType === "quiz") {
      navigate("/health-quiz", {
        state: {
          item: item,
          getUserProductClaimSelector: getUserProductClaimSelector,
          getPendingMonthsSelector: getPendingMonthsSelector?.data?.data?.pendingMonths
        },
      });
    }
  };

 
  useEffect(() => {
    if (updateUserProductClaimSelector?.message) {
      messageApi.open({
        type: "error",
        content: updateUserProductClaimSelector?.message,
      });
      dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
    } else if (updateUserProductClaimSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: updateUserProductClaimSelector?.data?.message,
      });
      if(storeItem){
        window.open(storeItem?.urlData, "_blank");
      }
      dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
    }
  }, [updateUserProductClaimSelector]);

  return (
    <>
      {(getUserProductClaimSelector?.isLoading ||
        updateUserProductClaimSelector?.isLoading ||
        getPendingMonthsSelector?.isLoading ||
        getAllProductListSelector?.isLoading) && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="mainSection">
        <div className="overflowx w-100 mb-30">
          <div className="d-flex gap-8 align-center">
            {getPendingMonthsSelector?.data?.data?.pendingMonths?.map(
              (item) => {
                const statusClass =
                  item?.status === "pending"
                    ? "pending"
                    : item?.status === "complete"
                    ? "complete"
                    : item?.status === null
                    ? "statusNull"
                    : "disable";

                const currentMonthValue = moment().format("MMM 'YY");
                const isCurrentMonth = item?.value === currentMonthValue;
                const isActive = activeMonth?.value === item?.value;
                // active
                return (
                  <div
                    key={item?.value}
                    ref={isActive ? currentMonthRef : null}
                    className={`month fs-16 cursor-pointer ${statusClass} ${
                      isActive ? "active" : ""
                    } ${isCurrentMonth ? "currentMonth" : ""}`}
                    onClick={() => handleMonthsWiseData(item)}
                  >
                    {item?.value}
                  </div>
                );
              }
            )}
          </div>
        </div>
        {console.log(claimData,"ClaimDataaa")}
        {claimData?.filter((item) => item?.claimType !== "offlineClaim" && item?.claimType !== "doctorVisit")
          ?.length > 0 ? (
          <>
            {claimData
              ?.filter((item) => item?.claimType !== "offlineClaim" && item?.claimType !== "doctorVisit")
              ?.map((item, index) => (
                <div className="claimGrid" key={index}>
                  <div
                    className={`claimCard tgb fs-20 mb-20 ${
                      item?.claimStatus.toUpperCase() === "COMPLETE" &&
                      item?.claimType === "form"
                        ? "disabled"
                        : ""
                    }`}
                    onClick={() =>
                      !(
                        item.claimStatus.toUpperCase() === "COMPLETE" &&
                        item.claimType === "form"
                      ) && handleClaimCards(item)
                    }
                  >
                    {item?.claimName}
                    {item?.claimStatus.toUpperCase() === "COMPLETE" &&
                    (item?.claimType === "form" ||
                      item?.claimType === "quiz") ? null : (
                      <img src={rightArrow} alt="Right Arrow" />
                    )}
                    {item?.claimStatus.toUpperCase() === "COMPLETE" &&
                      (item?.claimType === "form" ||
                        item?.claimType === "quiz") && (
                        <img src={completed} alt="Completed" />
                      )}
                  </div>
                </div>
              ))}
          </>
        ) : (
          <NoDataFound />
        )}
      </div>

      {showErrorMessageModal && (
        <Modal
          className="custom-modal responsiveModal text-center"
          open={showErrorMessageModal}
          onCancel={() => setShowErrorMessageModal(false)}
          footer={null}
          closeIcon={null}
          centered
          maskClosable={false}
        >
          <div className="gb fs-20 text-center mb-40">{errorMessage}</div>
          <div className="d-flex justify-center">
            <button className="saveBtn" onClick={handleYesClick}>Yes</button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Claims;
